<script>
	// Import router
	import { Router, Route } from "svelte-navigator";
	// SPA pages
	import About from "./Pages/About.svelte";
	import Contact from "./Pages/Contact.svelte";
	import Home from "./Pages/Home.svelte";
	import Media from "./Pages/Media.svelte";
	import Merch from "./Pages/Merch.svelte";
	import Shows from "./Pages/Shows.svelte";
	import NotFound from "./Pages/NotFound.svelte";

	// Components
	import Nav from "./Components/Nav.svelte";

	// Constants
	const links = ["Home", "About", "Contact", "Media", "Merch", "Shows"];
	const pageComponents = {
		Home,
		About,
		Contact,
		Media,
		Merch,
		Shows,
		NotFound,
	};
</script>

<Router>
	<header>
		<Nav {links} />
	</header>
	{#each links as route}
		<Route
			path={route === "Home" ? "/" : route.toLowerCase()}
			component={pageComponents[route]}
		/>
	{/each}
	<Route path="*" component={NotFound} />
</Router>
